import { CustoAdicionalTipo } from "./custo-adicional-tipo.model";

export class CustoAdicional {
    id: number;
    estimativaId: number;
    descricao: string;
    quantidade: number;
    valor: number;
    idCustoAdicionalTipo: number;
    tb_custo_adicional_tipo: CustoAdicionalTipo[];
}